"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Heading from "./webflow_modules/Basic/components/Heading";
import Section from "./webflow_modules/Layout/components/Section";
import Span from "./webflow_modules/Basic/components/Span";
import { ButtonPrimaryWhite } from "./ButtonPrimaryWhite";
import { Explore } from "./Explore";

export function Communities({}) {
  return (
    <Section className={"communities"} tag={"section"}>
      <Block className={"padding-global"} tag={"div"}>
        <Block tag={"div"}>
          <Block className={"padding-section-large"} tag={"div"}>
            <Block className={"communities_header"} tag={"div"}>
              <Block className={"communities_heading-wrapper"} tag={"div"}>
                <Heading tag={"h2"}>
                  {"Our Strong and "}
                  <br />
                  <Span className={"text-color-blue"}>
                    {"Vibrant Communities"}
                  </Span>
                </Heading>
              </Block>
              <Block className={"decoration-line"} tag={"wrapper"} />
            </Block>
            <Explore />
            <Block className={"margin-top margin-xlarge"} tag={"div"}>
              <Block className={"button-group is-centered"} tag={"div"}>
                <ButtonPrimaryWhite
                  link={{
                    href: "/locations/",
                  }}
                  text={"Explore Our Communities"}
                />
              </Block>
            </Block>
          </Block>
        </Block>
      </Block>
    </Section>
  );
}
